/* __next_internal_client_entry_do_not_use__ Header auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { HeaderDesktop } from "@faire/retailer-visitor-shared/components/Header/desktop/HeaderDesktop";
import { HeaderMobile } from "@faire/retailer-visitor-shared/components/Header/mobile/HeaderMobile";
import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";
import { PageLoadEvent } from "@faire/retailer-visitor-shared/services/performance/const";
import { PerformanceMarker } from "@faire/retailer-visitor-shared/services/performance/PerformanceMarker";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
export var Header = function() {
    useEffect(function() {
        PerformanceMarker.get().mark(PageLoadEvent.firstPaint);
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(HeaderWithPrerenderHack, {}),
            /*#__PURE__*/ _jsx(SkipToMainLink, {
                tabIndex: 1,
                linkTo: "#main",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "g1Th/S",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Skip to main content"
                        }
                    ]
                })
            })
        ]
    });
};
var HeaderWithPrerenderHack = function() {
    /**
     * Prerender only caches the HTML for one viewport size. This means that if
     * the crawler is on mobile, it will see the cached HTML for desktop. This
     * will affect the rating of the page in terms of mobile friendliness.
     * To avoid this, we render the both headers for prerender, and then use the
     * CSS media query to hide the one that is not needed. This has performance
     * implications, so we should only do this for prerender.
     */ if (isPrerender()) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(StyledHeaderDesktop, {}),
                /*#__PURE__*/ _jsx(MaybeHeaderMobile, {})
            ]
        });
    }
    /**
     * If we are not in pre-render, we can use the viewport hook to determine
     * which header to render.
     */ return /*#__PURE__*/ _jsx(MobileOrDesktopHeader, {});
};
var MobileOrDesktopHeader = function() {
    var isDesktopAndAbove = useViewport().isDesktopAndAbove;
    return isDesktopAndAbove ? /*#__PURE__*/ _jsx(StyledHeaderDesktop, {}) : /*#__PURE__*/ _jsx(MaybeHeaderMobile, {});
};
var MaybeHeaderMobile = function() {
    if (isMobileApp()) {
        return null;
    }
    return /*#__PURE__*/ _jsx(StyledHeaderMobile, {});
};
// Note StyledHeaderDesktop and StyledHeaderMobile are defined to avoid viewport
//  mismatch between server and client. Please do not remove them unless you
//  know what you are doing.
var StyledHeaderDesktop = styled(HeaderDesktop).withConfig({
    componentId: "sc-cdb519f7-0"
})([
    "",
    "{display:none;}"
], responsiveMediaQueries.tabletAndBelow);
var StyledHeaderMobile = styled(HeaderMobile).withConfig({
    componentId: "sc-cdb519f7-1"
})([
    "",
    "{display:none;}"
], responsiveMediaQueries.desktopAndAbove);
var SkipToMainLink = styled(EmbeddedLink).withConfig({
    componentId: "sc-cdb519f7-2"
})([
    "background:",
    ";left:50%;padding:8px;position:fixed;top:0;transform:translateY(-100%);transition:transform 0.3s;z-index:100;&:focus{transform:translateY(0%);}@media print{display:none;}"
], Core.surface.inverse);
